import { muiTheme } from "@/styles/theme";
import { Box, Typography } from "@mui/material";
import EditLeadType from "@/modules/lead-page/components/lead-info/lead-type/edit-lead-type";
import { useState } from "react";
import { LeadTypeOption } from "@/modules/lead-page/constants";
import { nawyTheme } from "@/styles/nawy-theme/nawy-theme";

const ReassignNoreferral = () => {
  const [reassignNoReferralModal, setReassignNoReferralModal] =
    useState<boolean>(false);

  return (
    <>
      <Box
        sx={{
          display: "flex",
          gap: nawyTheme.nawy.spacing.xs,
          padding: nawyTheme.nawy.spacing.xs,
          alignItems: "center",

          cursor: "pointer",
          ":hover": {
            backgroundColor:
              muiTheme.colorSchemes.light.palette.main.actionDisabled,
          },
        }}
        onClick={() => setReassignNoReferralModal(true)}
      >
        <Typography
          sx={{
            color: nawyTheme.nawy.colors.semantic.text.primary,
            ...nawyTheme.nawy.typography.english.variants.body.md.regular,
          }}
        >
          Reassign to a different team (no referral)
        </Typography>
      </Box>
      <EditLeadType
        optionId={LeadTypeOption.ReassignNoReferral}
        modalOpen={reassignNoReferralModal}
        setModalOpen={setReassignNoReferralModal}
      />
    </>
  );
};

export default ReassignNoreferral;
